var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTradingHistory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 16C2 23.7336 8.2664 30 16 30C23.7336 30 30 23.7336 30 16C30 8.2664 23.7336 2 16 2C8.2664 2 2 8.2664 2 16ZM23 16.8064C23 17.5792 22.0648 17.9768 21.5104 17.4224L20.3288 16.2408L16.8288 19.7408C16.3696 20.1944 15.6304 20.1944 15.1768 19.7408L12.5 17.064L10.82 18.744C10.596 18.9736 10.2264 18.9736 9.9968 18.744L9.1736 17.9208C8.944 17.6968 8.944 17.3272 9.1736 17.0976L11.6768 14.5944C12.136 14.1408 12.8752 14.1408 13.3288 14.5944L16.0056 17.2712L18.6824 14.5888L17.5008 13.4072C16.9464 12.864 17.3328 11.9176 18.1168 11.9176H22.4232C22.748 11.9176 23.0056 12.1808 23 12.5V16.8064Z",
    fill: "#674df6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTradingHistory);
export default __webpack_public_path__ + "static/media/icon-trading-history.ca843a8e.svg";
export { ForwardRef as ReactComponent };